import HandsFreeSearch from './HandsFreeSearch.jsx';

export default HandsFreeSearch;


// WEBPACK FOOTER //
// ./src/components/HandsFreeSearch/index.jsx